import { animated } from '#app/components/Primitives/Animated.js';
import { css, styled } from 'styled-components';

export const ProfileServicesWrapper = styled.div<{
  noMarginTop: boolean;
  visitorCanEdit: boolean;
}>`
  max-width: 1096px;
  margin: 24px auto;

  ${({ noMarginTop, visitorCanEdit }) => css`
    margin-bottom: ${visitorCanEdit ? '112px' : '24px'};
    margin-top: ${noMarginTop ? '0' : undefined};
  `}
`;

export const ServiceCards = styled(animated.div)<{
  withMarginTop: boolean;
}>`
  ${({ theme, withMarginTop }) => css`
    ${withMarginTop
      ? css`
          margin-top: 32px;
        `
      : undefined}

    & > * + * {
      margin-top: 32px;
    }

    ${theme.mediaQueries.md} {
      ${withMarginTop
        ? css`
            margin-top: 40px;
          `
        : undefined}

      & > * + * {
        margin-top: 40px;
      }
    }
  `}
`;
